class GeometryTable {
  constructor(el) {
    this.$current = null;
    this.$el = el;
    this.itemClassName = 'x-product-size__mobile-table-li';
    this.itemActiveClassName = 'x-product-size__mobile-table-li--active';
    this.init();
  }
  init() {
    this.$el.querySelectorAll(`.${this.itemClassName}`).forEach(($item) => {
      if ($item.classList.contains(this.itemActiveClassName)) {
        this.$current = $item;
      }
      $item.addEventListener('click', () => {
        if (this.$current === $item) return;

        if (this.$current) {
          this.$current.classList.remove(this.itemActiveClassName);
        }

        $item.classList.add(this.itemActiveClassName);
        this.$current = $item;
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  let variantSlider = null;

  function initVariantSlider() {
    const $slide = document.querySelector('#x-product-variants__slide');
    if (!$slide) return;

    // 如果已存在实例，先彻底销毁，清理内部绑定的事件和复制节点
    if (variantSlider) {
      variantSlider.destroy(true, true);
      variantSlider = null;
    }

    // 获取真实的 slide 数量（排除 Swiper 自动生成的 duplicate 节点）
    const slideCount = $slide.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length;

    const sliderConfig = {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: slideCount > 1, // 只有当图片大于 1 张时，才开启循环，彻底消灭 Warning
      navigation: {
        nextEl: '.x-product-variants__slide-button--next',
        prevEl: '.x-product-variants__slide-button--prev',
      },
      pagination: {
        el: $slide.querySelector('.x-product-variants__slider-pagination'),
        clickable: true,
        type: 'custom',
        renderCustom: function (swiper, current, total) {
          let dotIndex = 0;
          const dots = [];
          while (dotIndex < total) {
            const isActive =
              dotIndex === current - 1 ? 'x-product-variants__slider-pagination-dot--active' : '';
            dots.push(
              `<span class="x-product-variants__slider-pagination-dot ${isActive}">${current}</span>`
            );
            dotIndex++;
          }
          return dots.join('');
        },
      },
    };
    variantSlider = new Swiper($slide, sliderConfig);
  }

  let glightboxInstance = null;
  function initLightGallery() {
    // 1. 如果存在旧实例，先销毁它 (完美兼容你切换 Variant 的场景)
    if (glightboxInstance) {
      glightboxInstance.destroy();
    }

    // 2. 重新初始化 GLightbox
    glightboxInstance = GLightbox({
      selector: '.x-product-variants__slide-expand',
      touchNavigation: true,
      loop: true,
      zoomable: true,
      openEffect: 'zoom',
      closeEffect: 'zoom',
      descPosition: 'bottom',
    });

    // 修复 GLightbox 右键菜单导致的“幽灵拖拽”Bug
    document.addEventListener(
      'mousedown',
      (e) => {
        // e.button === 2 代表鼠标右键
        if (e.button === 2 && e.target.closest('.glightbox-container')) {
          e.stopPropagation();
        }
      },
      true
    );

    document.addEventListener(
      'contextmenu',
      (e) => {
        if (e.target.closest('.glightbox-container')) {
          window.dispatchEvent(new MouseEvent('mouseup'));
        }
      },
      true
    );
    const $sliderContainer = document.querySelector('#x-product-variants__slide');
    if ($sliderContainer) {
      $sliderContainer.addEventListener('click', (e) => {
        // 如果点击的是图片本身，且不是左右切换箭头
        if (
          e.target.tagName === 'IMG' &&
          !e.target.closest('.swiper-button-next') &&
          !e.target.closest('.swiper-button-prev')
        ) {
          // 找到这张图片所在的具体 slide 容器 (假设使用了 swiper，类名是 swiper-slide)
          const currentSlide = e.target.closest('.swiper-slide');
          if (currentSlide) {
            // 找到这个 slide 里的那个原始 expand (放大) 按钮，并模拟点击
            const expandBtn = currentSlide.querySelector('.x-product-variants__slide-expand');
            if (expandBtn) {
              expandBtn.click();
            }
          }
        }
      });
    }
  }

  let currentSelection = {};
  let resolvedVariant = null;

  // 辅助函数：根据当前的选项寻找匹配的 Variant
  function getVariantBySelection(selection) {
    return window.VARIANTS.find((v) => {
      return (
        (!selection.option1 || v.option1 === selection.option1) &&
        (!selection.option2 || v.option2 === selection.option2) &&
        (!selection.option3 || v.option3 === selection.option3)
      );
    });
  }

  // 核心渲染引擎：根据状态机重新绘制 UI
  function updateOptionsUI() {
    const $optionGroups = document.querySelectorAll('.x-product-variants__option-group');

    $optionGroups.forEach(($group) => {
      const indexKey = $group.getAttribute('data-option-index');
      const selectedValue = currentSelection[indexKey];

      // 1. 更新顶部文本 Label
      const $labelVal = $group.querySelector('.x-product-variants__option-selected-val');
      if ($labelVal) $labelVal.textContent = selectedValue;

      // 2. 遍历该参数下的所有按钮并计算状态
      $group.querySelectorAll('.x-product-variants__option-item').forEach(($item) => {
        const itemVal = $item.getAttribute('data-value');
        const isColor = $item.classList.contains('x-product-variants__color-swatch-item');
        const isSize = $item.classList.contains('x-product-variants__size-item');
        const isGeneric = $item.classList.contains('x-product-variants__generic-item');

        // 清除所有高亮状态
        $item.classList.remove(
          'x-product-variants__color-swatch-item--active',
          'x-product-variants__size-item--selected',
          'x-product-variants__generic-item--selected'
        );

        // 设置当前高亮
        if (itemVal === selectedValue) {
          if (isColor) $item.classList.add('x-product-variants__color-swatch-item--active');
          if (isSize) $item.classList.add('x-product-variants__size-item--selected');
          if (isGeneric) $item.classList.add('x-product-variants__generic-item--selected');
        }

        // 3. 计算选项的售罄状态 (结合其他已选项推断后续是否可用)
        const mockSelection = { ...currentSelection, [indexKey]: itemVal };
        const mockVariant = getVariantBySelection(mockSelection);
        const isAvailable = mockVariant && globalInventoryMap[mockVariant.id];

        // 移除旧的不可用状态
        $item.classList.remove('x-product-variants__size-item--disabled');

        // 除了颜色模块外，其他模块缺货置灰打叉
        if (isSize && !isAvailable) {
          $item.classList.add('x-product-variants__size-item--disabled');
        }
      });
    });
  }

  // 动态处理 Waitlist 表单填充
  function handleDynamicWaitlistForm($targetForm) {
    const variantId = $targetForm.querySelector('.product-variant-id').value;
    const model = document.querySelector('.x-product-variants__title').textContent;

    // 动态提取颜色和尺寸，以便兼容现有的 Cloudflare Worker 后端接口
    let colorVal = '-',
      sizeVal = '-';
    document.querySelectorAll('.x-product-variants__option-group').forEach(($g) => {
      const name = $g.getAttribute('data-name');
      const val = currentSelection[$g.getAttribute('data-option-index')];
      if (name.includes('color')) colorVal = val;
      if (name.includes('size')) sizeVal = val;
    });

    const $wishlistForm = document.querySelector('.x-wishlist-form');
    if ($wishlistForm) {
      $wishlistForm.querySelector('input[name="variantId"]').value = variantId;
      $wishlistForm.querySelector('input[name="model"]').value = model;
      // 容错降级：如果没匹配到 color/size 字眼，强行使用 option1 和 option2 防止接口报错
      $wishlistForm.querySelector('input[name="colorway"]').value =
        colorVal !== '-' ? colorVal : currentSelection.option1 || '-';
      $wishlistForm.querySelector('input[name="size"]').value =
        sizeVal !== '-' ? sizeVal : currentSelection.option2 || '-';
    }
    publish(PUB_SUB_EVENTS.xModalOpen, { modalName: 'wishlist-form' });
  }

  // button bar information template, used to construct the description text in the bottom bar and can be extended in the future if needed
  let variantInfoTemplate = ['colorway', 'size'];
  // 更新变体附加信息（价格栏、URL等）
  function updateVariantInfo() {
    if (!resolvedVariant) return;

    // if size is not selected, do not update url
    let needUpdateUrl = false;
    // 没有选中size的时候不要渲染size的信息，保持和用户选择的一致性
    // 拼装底部黑条的描述文案 (只拼装有效的值)
    const descHtml = variantInfoTemplate
      .map((templateKey, templateIndex) => {
        const variantValue = currentSelection[`option${templateIndex + 1}`];
        if (
          templateKey.includes('size') &&
          typeof variantValue === 'string' &&
          variantValue !== ''
        ) {
          needUpdateUrl = true;
        }
        if (templateKey.includes('color')) {
          return `<span>${variantValue}</span>`;
        } else {
          return `<span>${templateKey}: ${variantValue || '-'}</span>`;
        }
      })
      .join('');

    const $descContainer = document.querySelector('.x-product-variants__precount-content-describe');
    if ($descContainer) {
      $descContainer.innerHTML = descHtml + `<span>quantity: 1</span>`;
    }

    const $variantPrice = document.querySelector('.x-product-variants__price-content');
    if ($variantPrice) {
      $variantPrice.innerHTML = `<span>$${xUtils.formatVariantPrice(resolvedVariant.price)}</span>`;
    }
    if (needUpdateUrl) {
      window.xUtils.updateUrl({ variant: encodeURIComponent(resolvedVariant.id) });
    }
  }

  // price and buy-button area
  const $operationArea = document.querySelector('.x-product-variants__precount-operations');

  const $featureList = document.querySelector('.x-product-feature__list');
  const expandClass = 'x-product-feature__item--expand';
  const foldClass = 'x-product-feature__item--fold';
  const FIX_HEIGHT = xUtils.isMobile() ? 24 : 0;
  $featureList.querySelectorAll('.x-product-feature__sub-title').forEach(($title, index) => {
    const $list = $title.parentNode;

    if (!xUtils.isMobile() && index > 0) {
      $list.classList.add(expandClass);
      $list.classList.remove(foldClass);
    }

    if ($list.classList.contains(foldClass)) {
      $list.style.height = $title.offsetHeight + FIX_HEIGHT + 'px';
    } else {
      $list.style.height = $list.scrollHeight + 'px';
    }

    $title.addEventListener('click', function () {
      if ($list.classList.contains(expandClass)) {
        $list.classList.remove(expandClass);
        $list.classList.add(foldClass);
        requestAnimationFrame(() => {
          $list.style.height = $title.offsetHeight + FIX_HEIGHT + 'px';
        });
      } else {
        $list.classList.remove(foldClass);
        $list.classList.add(expandClass);

        requestAnimationFrame(() => {
          $list.style.height = $list.scrollHeight + 'px';
        });
      }
    });
  });

  document.querySelector('#product-geometry-link').addEventListener('click', (e) => {
    const $anchor = document.querySelector('#product-geometry');
    const $list = $anchor.parentNode;

    if (!$list.classList.contains(expandClass)) {
      $list.classList.remove(foldClass);
      $list.classList.add(expandClass);

      requestAnimationFrame(() => {
        $list.style.height = $list.scrollHeight + 'px';
      });
    }
  });

  let $currentSizeItem = null;
  const sizeExpandClass = 'x-product-size__item--expand';
  document.querySelectorAll('.x-product-size__item').forEach(function ($item) {
    const $folder = $item.closest('.x-product-feature__item');

    if ($item.classList.contains(sizeExpandClass)) {
      $currentSizeItem = $item;
    }
    $item.querySelector('.x-product-size__title').addEventListener('click', function () {
      if ($currentSizeItem === $item) {
        $currentSizeItem.classList.remove(sizeExpandClass);
        $currentSizeItem = null;
      } else {
        if ($currentSizeItem) {
          $currentSizeItem.classList.remove(sizeExpandClass);
        }
        $currentSizeItem = $item;
        $currentSizeItem.classList.add('x-product-size__item--expand');
      }
      // set auto to recalculate height
      $folder.style.height = 'auto';
      // reset height
      requestAnimationFrame(() => {
        $folder.style.height = $folder.scrollHeight + 'px';
      });
    });
  });

  document
    .querySelectorAll('.x-product-size__mobile-table-container')
    .forEach(function ($container) {
      new GeometryTable($container);
    });

  const containerSelector = '.x-product-feature__detail';
  const $featureSliderContainer = document.querySelector(containerSelector);
  const featureSliderConfig = xUtils.isMobile()
    ? {
        slidesPerView: 'auto',
        spaceBetween: 20,
        freeMode: true,
        mousewheel: {
          enabled: true,
          sensitivity: 1,
          releaseOnEdges: false,
          forceToAxis: true,
        },
        scrollbar: {
          el: null,
        },
      }
    : {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 16,
        speed: 500,
        nested: true,
        watchSlidesProgress: true,
        grabCursor: true,
        navigation: {
          nextEl: '.x-product-feature__detail-button-next',
          prevEl: '.x-product-feature__detail-button-prev',
        },
        mousewheel: {
          enabled: true,
          sensitivity: 1,
          releaseOnEdges: true,
          forceToAxis: true,
          thresholdDelta: 10,
          eventsTarget: containerSelector,
        },
      };
  const featureSlider = new Swiper(containerSelector, featureSliderConfig);

  $featureSliderContainer.addEventListener(
    'wheel',
    (e) => {
      // if scroll to the end, go through
      if (
        (featureSlider.isEnd && e.deltaY > 0) ||
        (featureSlider.isBeginning && e.deltaY < 0) ||
        xUtils.isMobile()
      ) {
        return;
      }

      e.preventDefault();

      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
        // stop broswser back or forward
        // trigger slide
        if (Math.abs(e.deltaX) > 10) {
          if (e.deltaX > 0) {
            featureSlider.slideNext();
          } else {
            featureSlider.slidePrev();
          }
        }
      } else {
        if (e.deltaY > 0) {
          featureSlider.slideNext();
        } else {
          featureSlider.slidePrev();
        }
      }
    },
    { passive: false }
  );

  const $slider = document.querySelector('.x-product-review');
  const mediaSliderConfig = xUtils.isMobile()
    ? {
        slidesPerView: 'auto',
        spaceBetween: 16,
        freeMode: true,
        mousewheel: {
          enabled: true,
          sensitivity: 1,
          releaseOnEdges: true,
          forceToAxis: true,
        },
        scrollbar: {
          el: null,
        },
      }
    : {
        slidesPerView: 'auto',
        spaceBetween: 16,
        mousewheel: {
          enabled: true,
          sensitivity: 1,
          releaseOnEdges: true,
          forceToAxis: true,
        },
        navigation: {
          prevEl: '.x-product-slider__pagination-prev',
          nextEl: '.x-product-slider__pagination-next',
        },
      };
  if ($slider) {
    const mediaSlider = new Swiper($slider, mediaSliderConfig);
    $slider.addEventListener(
      'wheel',
      (e) => {
        if (
          (mediaSlider.isEnd && e.deltaY > 0) ||
          (mediaSlider.isBeginning && e.deltaY < 0) ||
          xUtils.isMobile()
        ) {
          return;
        }
        e.preventDefault();
      },
      { passive: false }
    );
  }

  // ---------- x-product-support 移动端 Swiper（整合自原 x-product-support.js） ----------
  (function initProductSupport() {
    const MOBILE_QUERY = '(max-width: 768px)';
    const mql = window.matchMedia(MOBILE_QUERY);
    const instances = new WeakMap();

    function buildSwiper(root) {
      if (typeof Swiper === 'undefined') return null;
      const container = root.querySelector('.x-product-support__track');
      if (!container) return null;
      const isFree = root.dataset.slideMode === 'free';
      return new Swiper(container, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        slidesPerGroup: 1,
        freeMode: isFree,
        observer: true,
        observeParents: true,
        mousewheel: {
          enabled: true,
          sensitivity: 1,
          releaseOnEdges: true,
          forceToAxis: true,
        },
      });
    }

    // 移动端确保有实例，桌面端销毁还原 grid
    function sync(root) {
      if (!root) return;
      const existing = instances.get(root);
      if (mql.matches) {
        if (!existing) {
          const sw = buildSwiper(root);
          if (sw) instances.set(root, sw);
        }
      } else if (existing) {
        existing.destroy(true, true);
        instances.delete(root);
      }
    }

    function syncAll() {
      document.querySelectorAll('.x-product-support').forEach(sync);
    }

    if (mql.addEventListener) mql.addEventListener('change', syncAll);

    syncAll();

    // 点击「Take a peek in the box」卡片：移动端确保 unboxing 手风琴已展开
    // 复用上方 feature 的 expand/fold 机制（#unboxing 本身即一个 feature 手风琴项，
    // 结构同 #product-geometry-link 的处理）
    document.querySelectorAll('a.x-support__card--accessories').forEach(($link) => {
      const href = $link.getAttribute('href') || '';
      if (href.charAt(0) !== '#') return;
      $link.addEventListener('click', () => {
        if (!xUtils.isMobile()) return; // 桌面端手风琴默认已展开，无需处理
        const $item = document.querySelector(href);
        if (!$item || !$item.classList.contains(foldClass)) return;
        $item.classList.remove(foldClass);
        $item.classList.add(expandClass);
        requestAnimationFrame(() => {
          $item.style.height = $item.scrollHeight + 'px';
        });
      });
    });

    document.addEventListener('shopify:section:load', (e) => {
      const el =
        e.target && e.target.querySelector ? e.target.querySelector('.x-product-support') : null;
      if (el) sync(el);
    });
  })();

  // 修改原有的状态栏更新函数
  function updateButtonStatus(isAvailable) {
    const $operationArea = document.querySelector('.x-product-variants__precount-operations');
    if (!$operationArea) return;

    const $hiddenInput = $operationArea.querySelector('.product-variant-id');
    const $buyBtn = $operationArea.querySelector('.x-product__buy-button');
    const $buyBtnText = $operationArea.querySelector('.x-buy-button-text');

    // 校验是否所有必需的选项都已经选择
    const totalOptions = document.querySelectorAll('.x-product-variants__option-group').length;
    const currentSelectedCount = Object.values(currentSelection).filter((val) => val).length;

    if (currentSelectedCount < totalOptions || !resolvedVariant) {
      if ($hiddenInput) $hiddenInput.value = '';
      if ($buyBtnText) $buyBtnText.textContent = 'Choose Options';
      if ($buyBtn) {
        $buyBtn.setAttribute('data-ready', 'false');
        $buyBtn.setAttribute('data-available', 'false');
      }
    } else {
      // if choose current size, set variant id
      if ($hiddenInput) $hiddenInput.value = resolvedVariant.id;
      if ($buyBtn) {
        $buyBtn.setAttribute('data-ready', 'true');
        if (!isAvailable) {
          // not available, show notify me or coming soon
          $buyBtn.setAttribute('data-available', 'false');
          // get country code
          const currentCountry = $buyBtn.getAttribute('data-country');
          if ($buyBtnText) {
            // only notify me for us
            $buyBtnText.textContent = currentCountry === 'US' ? 'Notify Me' : 'Sold out';
          }
        } else {
          // inventory available, show Add to cart
          $buyBtn.setAttribute('data-available', 'true');
          if ($buyBtnText) $buyBtnText.textContent = 'Add to cart';
        }
      }
    }
    updateVariantInfo();
  }

  const globalInventoryMap = {};
  async function fetchRealtimeInventory() {
    xUtils.showLoading();
    try {
      const res = await fetch(`${window.location.pathname}.js`);
      const productData = await res.json();

      productData.variants.forEach((v) => {
        globalInventoryMap[v.id] = v.available;
      });
    } catch (e) {
      console.error('Failed to fetch product inventory', e);
    } finally {
      xUtils.hideLoading();
    }
  }

  const variantCache = {};

  // 1：根据判定条件，按需将特征模块（Key Features & Specifications）写回 DOM
  function applyVariantHtml(htmlStringObj, onlyUpdatePrice, shouldUpdateFeatures) {
    const { variantSectionHtmlStr, introduceSectionHtmlStr, featureSectionHtmlStr } = htmlStringObj;
    // 1. parse variants html content
    const varaintSectionHtml = new DOMParser().parseFromString(variantSectionHtmlStr, 'text/html');
    const introduceSectionHtml = new DOMParser().parseFromString(
      introduceSectionHtmlStr,
      'text/html'
    );

    // 只有在显式要求更新特征大类时，才去实例化对应的 Feature HTML DOM
    const $featureSectionHtml =
      shouldUpdateFeatures && featureSectionHtmlStr
        ? new DOMParser().parseFromString(featureSectionHtmlStr, 'text/html')
        : null;

    // disable electric logic
    if ($operationArea) {
      const $newPriceAndBuyButton = varaintSectionHtml.querySelector(
        '.x-product-variants__precount-operations'
      );
      $operationArea.innerHTML = $newPriceAndBuyButton.innerHTML;
    }

    if (onlyUpdatePrice) return;
    // 2. update area selector
    // 2.1 get variant content dom
    const $newVariantSlide = varaintSectionHtml.querySelector('#x-product-variants__slide');
    const $newVariantSlideItems = $newVariantSlide.querySelectorAll(
      '.x-product-variants__slide-item'
    );
    // 2.2 get video content dom
    const $newVideoContent = introduceSectionHtml.querySelector('#product-video-area');
    const $videoContent = document.querySelector('#product-video-area');

    const $slideWrapper = document.querySelector('#x-product-variants__slide .swiper-wrapper');
    if ($slideWrapper) {
      $slideWrapper.innerHTML = '';
      $newVariantSlideItems.forEach(($item) => {
        $item.classList.remove(
          'swiper-slide-duplicate',
          'swiper-slide-duplicate-active',
          'swiper-slide-duplicate-next',
          'swiper-slide-duplicate-prev'
        );
        $slideWrapper.appendChild($item);
      });
    }

    // 重新实例化 Swiper 和画廊
    initVariantSlider();
    initLightGallery();
    // 3.2 update video area
    if ($videoContent && $newVideoContent) {
      $videoContent.innerHTML = $newVideoContent.innerHTML;
    }

    // 🔥 核心逻辑：重新打开并更新底部的 Feature Content 区域
    if (shouldUpdateFeatures && $featureSectionHtml) {
      // 1. 局部无感重载 Technical Specifications 模块
      const $newTechSpecsList = $featureSectionHtml.querySelector('.x-product-components__list');
      const $currentTechSpecsList = document.querySelector('.x-product-components__list');
      if ($newTechSpecsList && $currentTechSpecsList) {
        $currentTechSpecsList.innerHTML = $newTechSpecsList.innerHTML;
      }

      // 2. 局部无感重载 Key Features 模块 (包含桌面端的 Swiper 和移动端的平铺列表)
      const $newFeatureSliderLayer = $featureSectionHtml.querySelector(
        '#x-product-feature__detail-layer'
      );
      const $currentFeatureSliderLayer = document.querySelector('#x-product-feature__detail-layer');
      if ($newFeatureSliderLayer && $currentFeatureSliderLayer) {
        $currentFeatureSliderLayer.innerHTML = $newFeatureSliderLayer.innerHTML;

        // 特征块内容彻底更新后，必须重置并强刷 Swiper 状态，防止滚动穿透与死死卡住
        if (typeof featureSlider !== 'undefined' && featureSlider) {
          featureSlider.update();
          featureSlider.slideTo(0, 0);
        }
      }

      const $newFeatureMobileLayer = $featureSectionHtml.querySelector(
        '.x-product-feature__detail-layer--mobile'
      );
      const $currentFeatureMobileLayer = document.querySelector(
        '.x-product-feature__detail-layer--mobile'
      );
      if ($newFeatureMobileLayer && $currentFeatureMobileLayer) {
        $currentFeatureMobileLayer.innerHTML = $newFeatureMobileLayer.innerHTML;
      }

      // 3. 动态弹性重算手风琴外壳高度，防止更新 HTML 后因为文本长短不一导致内容被容器拦腰截断
      const $folder = $currentTechSpecsList
        ? $currentTechSpecsList.closest('.x-product-feature__item')
        : null;
      if ($folder && $folder.classList.contains('x-product-feature__item--expand')) {
        $folder.style.height = 'auto';
        requestAnimationFrame(() => {
          $folder.style.height = $folder.scrollHeight + 'px';
        });
      }
    }
  }

  // 2：根据 shouldUpdateFeatures 参数，在网络请求层进行按需节流与增量缓存校验
  async function fetchVariantData(variantId, onlyUpdatePrice, shouldUpdateFeatures) {
    window.xUtils.showLoading();
    try {
      // 只有当缓存存在，且满足“若需要更新特征，则缓存中必须存有特征 HTML”时，才判定命中缓存。
      // 这彻底瓦解了“先点 Size 变体建立残缺缓存，随后再点 Option1 导致网页无法刷新”的极端死锁 Bug。
      const isCacheValid =
        variantCache[variantId] &&
        (!shouldUpdateFeatures || variantCache[variantId].featureSectionHtmlStr);

      if (isCacheValid) {
        applyVariantHtml(variantCache[variantId], onlyUpdatePrice, shouldUpdateFeatures);
        const isAvailable = globalInventoryMap[variantId];
        updateButtonStatus(isAvailable);
      } else {
        const variantSectionId = document
          .querySelector('.x-product-variants')
          .id.replace('shopify-section-', '');
        const introduceSectionId = document
          .querySelector('.x-product-introduce')
          .id.replace('shopify-section-', '');
        const featureSectionId = document
          .querySelector('.x-product-feature')
          .id.replace('shopify-section-', '');

        // 网络请求级节流：不需要刷新特征时，绝不把 featureSectionId 塞进请求包，降低网络压力
        const sectionIds = [variantSectionId, introduceSectionId];
        if (shouldUpdateFeatures) {
          sectionIds.push(featureSectionId);
        }

        const url = `${window.location.pathname}?variant=${variantId}&sections=${sectionIds.join(',')}`;

        const res = await fetch(url);
        const parsedData = await res.json();

        const variantSectionHtmlStr = parsedData[variantSectionId];
        const introduceSectionHtmlStr = parsedData[introduceSectionId];
        const featureSectionHtmlStr = shouldUpdateFeatures ? parsedData[featureSectionId] : null;

        const strObj = {
          variantSectionHtmlStr,
          introduceSectionHtmlStr,
          featureSectionHtmlStr,
        };

        // 覆盖/增量写入全局运行内存缓存
        variantCache[variantId] = strObj;

        applyVariantHtml(strObj, onlyUpdatePrice, shouldUpdateFeatures);

        const isAvailable = globalInventoryMap[variantId];
        updateButtonStatus(isAvailable);
      }
    } catch (e) {
      console.error(e);
    } finally {
      window.xUtils.hideLoading();
    }
  }
  // buy button area
  // cancel hide on buy button area 2026/04/05
  // comment videoArea condition for archive
  function initToggleButtonArea() {
    const $buyButtonArea = document.querySelector('#product-buy-area');
    if (!$buyButtonArea) return;
    const $footerArea = document.querySelector('.x-footer');
    const hideClass = 'x-product-variants__precount---hidden';

    if (!$buyButtonArea) return;

    let isTicking = false;
    const updateButtonVisibility = () => {
      const footerRect = $footerArea.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const isTopInView = footerRect.top + 160 < viewportHeight;

      if (isTopInView) {
        $buyButtonArea.classList.add(hideClass);
      } else {
        $buyButtonArea.classList.remove(hideClass);
      }

      isTicking = false;
    };
    window.addEventListener('scroll', () => {
      if (!isTicking) {
        requestAnimationFrame(updateButtonVisibility);
        isTicking = true;
      }
    });
  }

  function initVideoAutoPlay() {
    const $videoArea = document.querySelector('#product-video-area');
    const observerOptions = {
      threshold: 0.5,
    };

    const videoObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const $videoContent = document.querySelector('.x-product-introduce-video__content');

        if (!$videoContent) return;
        const isVideo = $videoContent.classList.contains(
          'x-product-introduce-video__content-video'
        );
        const $desktopVideo = $videoContent.querySelector(
          '.x-product-introduce-video__video--desktop'
        );
        const $mobileVideo = $videoContent.querySelector(
          '.x-product-introduce-video__video--mobile'
        );
        const $ytIframe = $videoContent.querySelector('iframe');
        if (entry.isIntersecting) {
          if (isVideo) {
            xUtils.isMobile()
              ? $mobileVideo.play().catch((e) => console.log('Autoplay blocked:', e))
              : $desktopVideo.play().catch((e) => console.log('Autoplay blocked:', e));
          } else {
            $ytIframe.contentWindow.postMessage(
              '{"event":"command","func":"playVideo","args":""}',
              '*'
            );
          }
        }
      });
    }, observerOptions);

    videoObserver.observe($videoArea);
  }

  function initStoryVideoAutoPlay() {
    const $storyVideoArea = document.querySelectorAll('.x-product-introduce-quality__video-layer');
    const observerOptions = {
      threshold: 0.2,
    };
    const videoObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const $target = entry.target;
        const $desktopVideo = $target.querySelector('.x-product-introduce-quality__video--desktop');
        const $mobileVideo = $target.querySelector('.x-product-introduce-quality__video--mobile');
        if (entry.isIntersecting) {
          xUtils.isMobile()
            ? $mobileVideo.play().catch((e) => console.log('Autoplay blocked:', e))
            : $desktopVideo.play().catch((e) => console.log('Autoplay blocked:', e));
        }
      });
    }, observerOptions);

    $storyVideoArea.forEach(($areaItem) => {
      videoObserver.observe($areaItem);
    });
  }

  function initSizeGuide() {
    const $trigger = document.querySelector('.x-product-variants__size-ruler');
    if (!$trigger) return;
    $trigger.addEventListener('click', () => {
      publish(PUB_SUB_EVENTS.xModalOpen, { modalName: 'size-guide' });
    });
  }

  function initSizeRecommend() {
    // 联动开关：true 时，算出推荐尺码后自动选中 PDP 上对应 size（默认关闭，按需在此开启）
    const ENABLE_SIZE_AUTOSELECT = false;
    const modalName = 'size-recommend';

    const $root = document.querySelector('.x-size-recommend');
    if (!$root) return;

    // 身高、胯高各自的输入框（英制 Feet+Inches / 公制 cm）
    const heightEls = {
      ft: $root.querySelector('[name="heightFt"]'),
      inch: $root.querySelector('[name="heightIn"]'),
      cm: $root.querySelector('[name="heightCm"]'),
    };
    const inseamEls = {
      ft: null, // 胯高只用 inch，没有 ft
      inch: $root.querySelector('[name="inseamIn"]'),
      cm: $root.querySelector('[name="inseamCm"]'),
    };

    const currentUnit = () => ($root.getAttribute('data-unit') === 'cm' ? 'cm' : 'in');
    const round1 = (n) => parseFloat(n.toFixed(1)); // 四舍五入保留 1 位小数
    const numOrNull = (v) => {
      const n = parseFloat(v);
      return isNaN(n) ? null : n;
    };
    const showNum = (n) => (n === null || n === undefined ? '' : String(n));
    // 只保留数字和一个小数点
    const sanitize = (v) => {
      v = String(v).replace(/[^0-9.]/g, '');
      const i = v.indexOf('.');
      if (i !== -1) v = v.slice(0, i + 1) + v.slice(i + 1).replace(/\./g, '');
      return v;
    };

    const $start = document.querySelector('.x-size-recommend-card__start');
    const $guide = document.querySelector('.x-size-recommend-card__guide');

    const goStep = (step) => $root.setAttribute('data-step', String(step));
    const setUnit = (unit) => $root.setAttribute('data-unit', unit === 'cm' ? 'cm' : 'in');

    const resetInputs = () => {
      $root.querySelectorAll('.x-size-recommend__input').forEach(($i) => ($i.value = ''));
      heightField.reset();
      inseamField.reset();
      setUnit('in');
    };

    // 通用字段控制器：记录用户「权威输入」及其单位，换算只用于展示、不覆盖原值；
    // 切回原单位时还原用户原始输入，避免重复换算导致精度漂移。
    const makeField = (els) => {
      let store = null; // { unit:'in', ft, inch } | { unit:'cm', cm }
      const hasFt = !!els.ft; // 胯高英制只有 inch，没有 ft
      const wrapOf = ($i) => $i && $i.closest('.x-size-recommend__input-wrap');
      const errorOf = ($i) => {
        const $f = $i && $i.closest('.x-size-recommend__input-field');
        return $f ? $f.querySelector('.x-size-recommend__error') : null;
      };
      // 当前单位下的可见输入（英制 ft+in / 公制 cm）
      const visibleInputs = () =>
        currentUnit() === 'cm' ? [els.cm] : hasFt ? [els.ft, els.inch] : [els.inch];
      // 每个输入框各自的报错：标红输入区 + 显隐它自己的报错文案
      const setError = ($i, on) => {
        const $w = wrapOf($i);
        if ($w) $w.classList.toggle('x-size-recommend__input-wrap--error', on);
        const $e = errorOf($i);
        if ($e) $e.hidden = !on;
      };
      const clearErrors = () => {
        [els.ft, els.inch, els.cm].forEach(($i) => setError($i, false));
      };

      const capture = () => {
        if (currentUnit() === 'cm') {
          const cm = numOrNull(els.cm.value);
          store = cm === null ? null : { unit: 'cm', cm };
        } else {
          const ft = hasFt ? numOrNull(els.ft.value) : null;
          const inch = numOrNull(els.inch.value);
          store =
            ft === null && inch === null ? null : { unit: 'in', ft: ft || 0, inch: inch || 0 };
        }
      };

      const render = (unit) => {
        clearErrors(); // 切换单位后重置报错
        if (!store) {
          if (els.ft) els.ft.value = '';
          els.inch.value = '';
          els.cm.value = '';
          return;
        }
        if (unit === 'cm') {
          const cm = store.unit === 'cm' ? store.cm : round1((store.ft * 12 + store.inch) * 2.54);
          els.cm.value = showNum(cm);
        } else {
          let ft;
          let inch;
          if (store.unit === 'in') {
            ft = store.ft;
            inch = store.inch;
          } else {
            const totalIn = store.cm / 2.54;
            if (hasFt) {
              ft = Math.floor(totalIn / 12);
              inch = round1(totalIn - ft * 12);
              if (inch >= 12) {
                inch = round1(inch - 12);
                ft += 1;
              }
            } else {
              ft = 0;
              inch = round1(totalIn);
            }
          }
          if (els.ft) els.ft.value = showNum(ft);
          els.inch.value = showNum(inch);
        }
      };

      const toCm = () =>
        !store
          ? null
          : store.unit === 'cm'
            ? store.cm
            : round1((store.ft * 12 + store.inch) * 2.54);

      // 当前值换算成总英寸：英制输入直接累加（保留用户原值，不经 cm 中转），公制输入按 2.54 换算
      const toInches = () =>
        !store ? null : store.unit === 'in' ? store.ft * 12 + store.inch : store.cm / 2.54;

      // 校验当前单位下可见输入是否都已填写：空则标红并显示报错文案
      const validate = () => {
        let ok = true;
        visibleInputs().forEach(($i) => {
          const empty = $i.value.trim() === '';
          setError($i, empty);
          if (empty) ok = false;
        });
        return ok;
      };

      const reset = () => {
        store = null;
        clearErrors();
      };
      const bind = () => {
        [els.ft, els.inch, els.cm].forEach(($i) => {
          if (!$i) return;
          $i.addEventListener('input', () => {
            $i.value = sanitize($i.value); // 只允许数字和小数点
            capture();
            if ($i.value.trim() !== '') setError($i, false); // 填写后清除该输入自己的报错
          });
        });
      };

      return { render, toCm, toInches, reset, bind, validate };
    };

    const heightField = makeField(heightEls);
    const inseamField = makeField(inseamEls);

    // 尺码表数据（由 snippet 内联输出）：size / height(身高cm区间) / inseam(胯高cm区间) 三个并行数组
    let sizeData = { size: [], height: [], inseam: null };
    try {
      const $data = $root.querySelector('.x-size-recommend__data');
      if ($data) sizeData = JSON.parse($data.textContent);
    } catch (err) {
      sizeData = { size: [], height: [], inseam: null };
    }

    // 从区间字符串里解析 cm 段的上下界，如 "148 cm – 158 cm|4' 10" - 5' 2"" → { low:148, high:158 }
    const parseCmRange = (str) => {
      if (!str) return null;
      const m = String(str).match(/([\d.]+)\s*cm[^\d]*?([\d.]+)\s*cm/i);
      if (!m) return null;
      const a = parseFloat(m[1]);
      const b = parseFloat(m[2]);
      if (isNaN(a) || isNaN(b)) return null;
      return { low: Math.min(a, b), high: Math.max(a, b) };
    };

    // 解析单个英制边界 token 为总英寸，如 "5' 3\"" → 63、"29\"" → 29
    const parseInchesToken = (tok) => {
      const ftM = tok.match(/([\d.]+)\s*['′]/);
      const inM = tok.match(/([\d.]+)\s*["″]/);
      if (!ftM && !inM) return null;
      const ft = ftM ? parseFloat(ftM[1]) : 0;
      const inch = inM ? parseFloat(inM[1]) : 0;
      if (isNaN(ft) || isNaN(inch)) return null;
      return ft * 12 + inch;
    };
    // 从区间字符串里解析英制段（| 之后）的上下界（总英寸），如 "160 cm – 170 cm|5' 3\" - 5' 7\"" → { low:63, high:67 }
    const parseInRange = (str) => {
      if (!str) return null;
      const seg = String(str).indexOf('|') !== -1 ? String(str).split('|')[1] : String(str);
      const parts = seg.split(/\s*[–—-]\s*/).filter(Boolean);
      if (parts.length < 2) return null;
      const a = parseInchesToken(parts[0]);
      const b = parseInchesToken(parts[1]);
      if (a === null || b === null) return null;
      return { low: Math.min(a, b), high: Math.max(a, b) };
    };

    // 判断 value 是否落在区间字符串对应单位段内（闭区间）：cm 用 cm 段、in 用英制段，做到所见即所比
    const inRange = (value, str, unit) => {
      if (value === null || value === undefined) return false;
      const r = unit === 'cm' ? parseCmRange(str) : parseInRange(str);
      return !!(r && value >= r.low && value <= r.high);
    };

    // 推荐算法（胯高选填）：
    // 1. 只填身高：按身高命中档匹配
    // 2. 身高 + 胯高都填：以胯高为基准，取「身高与胯高命中同一档」的组合（交集）；两者不落同一档 → 无解
    // 3. 身高不落入任何档 → 无解
    // 4. 命中多档时统一推荐大的尺码（候选 index 升序 = 尺码升序，取末位）
    const calculateSize = ({ unit, height, inseam }) => {
      const sizes = Array.isArray(sizeData.size) ? sizeData.size : [];
      const heightRanges = Array.isArray(sizeData.height) ? sizeData.height : [];
      const inseamRanges = Array.isArray(sizeData.inseam) ? sizeData.inseam : null;
      const hasInseamData = inseamRanges && inseamRanges.length > 0;
      // 胯高选填：仅当尺码表配置了胯高数据、且用户确实填了胯高时，才纳入组合匹配
      const useInseam = hasInseamData && inseam !== null && inseam !== undefined;

      // 身高命中的所有档（相邻档边界重叠时可能多个），index 升序 = 尺码升序
      const hHits = [];
      for (let i = 0; i < heightRanges.length; i += 1) {
        if (inRange(height, heightRanges[i], unit)) hHits.push(i);
      }
      if (hHits.length === 0) return { ok: false }; // 身高超出所有档 → 无解

      // 组合命中：以胯高为基准、再用身高收窄，取「身高命中且胯高也命中」的同一档（交集）
      const combo = useInseam ? hHits.filter((i) => inRange(inseam, inseamRanges[i], unit)) : [];

      // 填了胯高、但身高与胯高命中不到同一档（交集为空）：
      // 改为身高、胯高各自取大码，合并去重后双推荐（≥2 码）；合并后同一码则退回普通单推荐
      if (useInseam && combo.length === 0) {
        // 胯高单独命中的所有档，index 升序 = 尺码升序
        const iHits = [];
        for (let i = 0; i < inseamRanges.length; i += 1) {
          if (inRange(inseam, inseamRanges[i], unit)) iHits.push(i);
        }
        // 身高取大码（hHits 末位）+ 胯高取大码（iHits 末位，胯高可能未命中任何档）
        const idxs = [hHits[hHits.length - 1]];
        if (iHits.length > 0) idxs.push(iHits[iHits.length - 1]);
        // 按尺码档 index 升序排序，再映射为尺码名并去重（避免同名重复，如 "L or L"）
        const seen = new Set();
        const dualSizes = [];
        idxs
          .sort((a, b) => a - b)
          .forEach((i) => {
            const s = sizes[i];
            if (s && !seen.has(s)) {
              seen.add(s);
              dualSizes.push(s);
            }
          });
        if (dualSizes.length === 0) return { ok: false }; // 尺码表配置有误兜底
        if (dualSizes.length === 1) return { ok: true, size: dualSizes[0] }; // 合并去重后同一码 → 普通单推荐
        return { ok: true, dual: true, sizes: dualSizes };
      }

      // 命中多个尺码时统一取偏大的一个：候选按 index 升序 = 尺码升序，取末位（尺码最大）
      // 未填胯高时直接用身高命中档，同样取最大
      const candidates = useInseam ? combo : hHits;
      const largest = candidates[candidates.length - 1];
      const matchedSize = sizes[largest];
      // 尺码表配置有误（size 项数 < 身高档位数，或该档 size 为空）时，走无解提示而非展示空白尺码
      if (!matchedSize) return { ok: false };
      return { ok: true, size: matchedSize };
    };

    // 所见即所比：按当前单位取值，配合尺码表对应单位段匹配，规避英制↔cm 换算的边界约整误差
    const readMeasurements = () => {
      const unit = currentUnit();
      return {
        unit,
        height: unit === 'cm' ? heightField.toCm() : heightField.toInches(),
        inseam: unit === 'cm' ? inseamField.toCm() : inseamField.toInches(),
      };
    };

    // 结果卡「Your measurements」按设计稿展示当前单位下的输入值：
    // 英制换算成总英寸、强制 1 位小数、紧贴 in（如 82.0in / 39.8in）；公制紧贴 cm、不强制小数（如 178cm / 76cm）
    const formatMeasurements = () => {
      if (currentUnit() === 'cm') {
        const h = heightEls.cm ? heightEls.cm.value.trim() : '';
        const i = inseamEls.cm ? inseamEls.cm.value.trim() : '';
        // 胯高选填：未填则只回显身高
        return i ? h + 'cm / ' + i + 'cm' : h + 'cm';
      }
      const ft = numOrNull(heightEls.ft && heightEls.ft.value) || 0;
      const inch = numOrNull(heightEls.inch && heightEls.inch.value) || 0;
      const li = numOrNull(inseamEls.inch && inseamEls.inch.value);
      const heightStr = (ft * 12 + inch).toFixed(1) + 'in';
      // 胯高选填：未填则只回显身高
      return li !== null ? heightStr + ' / ' + li.toFixed(1) + 'in' : heightStr;
    };

    const autoSelectSize = (size) => {
      if (!size) return;
      const target = String(size).toUpperCase();
      document.querySelectorAll('.x-product-variants__size-item').forEach(($item) => {
        const val = ($item.dataset.value || '').toUpperCase();
        if (val === target && !$item.classList.contains('x-product-variants__size-item--unreach')) {
          $item.click();
        }
      });
    };

    const renderResult = (result) => {
      // 切结果态：ok 单推荐、dual 双推荐（引导到店试骑）、nofit「找不到尺码」提示
      const state = !result.ok ? 'nofit' : result.dual ? 'dual' : 'ok';
      $root.setAttribute('data-result-state', state);
      if (state === 'nofit') return;
      if (state === 'dual') {
        // 尺码升序，用 " or " 连接（如 "L or XL"），同时填尺码行与说明段两处
        const label = result.sizes.join(' or ');
        $root.querySelectorAll('[data-result="dual-size"]').forEach(($el) => {
          $el.textContent = label;
        });
        return;
      }
      const $size = $root.querySelector('[data-result="size"]');
      const $measure = $root.querySelector('[data-result="measurements"]');
      if ($size) $size.textContent = result.size;
      if ($measure) $measure.textContent = result.measurements;
      if (ENABLE_SIZE_AUTOSELECT) autoSelectSize(result.size);
    };

    // 打开向导：从说明页开始
    $start &&
      $start.addEventListener('click', () => {
        resetInputs();
        goStep(1);
        publish(PUB_SUB_EVENTS.xModalOpen, { modalName });
      });

    // 「Size guide」文字：打开已有的静态尺码表
    $guide &&
      $guide.addEventListener('click', () => {
        publish(PUB_SUB_EVENTS.xModalOpen, { modalName: 'size-guide' });
      });

    // 关闭时重置回第一步（下次打开是说明页）
    subscribe(PUB_SUB_EVENTS.xModalClose, () => goStep(1));

    // 用户手动输入 → 更新权威值（程序化换算填值不触发 input 事件，不会污染原始值）
    heightField.bind();
    inseamField.bind();

    // 向导内部操作（Start / Next / Back / Start over / 单位切换）
    $root.addEventListener('click', (e) => {
      const $action = e.target.closest('[data-action]');
      if (!$action || !$root.contains($action)) return;
      const action = $action.dataset.action;

      if (action === 'unit') {
        const newUnit = $action.dataset.unit === 'cm' ? 'cm' : 'in';
        if (newUnit === currentUnit()) return;
        setUnit(newUnit);
        heightField.render(newUnit);
        inseamField.render(newUnit);
      } else if (action === 'to-measure') {
        goStep(2);
      } else if (action === 'next') {
        // 身高必填、胯高选填：仅身高未填则拦截，停在第二步并报错
        const okHeight = heightField.validate();
        if (!okHeight) return;
        const result = calculateSize(readMeasurements());
        if (result.ok) result.measurements = formatMeasurements();
        renderResult(result);
        goStep(3);
      } else if (action === 'back') {
        const current = $root.getAttribute('data-step');
        goStep(current === '3' ? 2 : 1);
      } else if (action === 'mobile-back') {
        // 移动端顶栏返回：step1 关闭弹窗，step2→1、step3→2
        const current = $root.getAttribute('data-step');
        if (current === '1') {
          const $xmodal = document.querySelector('x-modal[data-modal-name="size-recommend"]');
          if ($xmodal && typeof $xmodal.toggleModal === 'function') $xmodal.toggleModal(false);
          publish(PUB_SUB_EVENTS.xModalClose);
        } else {
          goStep(current === '3' ? 2 : 1);
        }
      } else if (action === 'restart') {
        resetInputs();
        goStep(1);
      }
    });
  }

  function initAssemblingVideo() {
    const unboxingLightbox = GLightbox({
      selector: '.js-unboxing-lightbox',
      skin: 'x-unboxing-skin',
      touchNavigation: false,
      loop: false,
      autoplayVideos: true,
      draggable: false,
      openEffect: 'zoom',
      closeEffect: 'zoom',
      width: '1140px',
      videosWidth: '1140px',
    });
  }

  // 卡片3(Support 板块)Accessory Box 照片:点卡片打开自建 x-modal 弹层,遮罩上居中展示图片(约 1200 宽)
  function initAccessoryModal() {
    const $trigger = document.querySelector('.js-accessory-modal');
    const $image = document.querySelector('.js-accessory-modal-image');
    if (!$trigger || !$image) return;

    const $box = $image.closest('.x-accessory-modal');
    let loaded = false;

    $trigger.addEventListener('click', (e) => {
      // 拦截降级 href,改为打开弹层
      e.preventDefault();

      // 首次打开时才给大图赋 src(懒加载,不占首屏);加载完标记 is-loaded 移除骑行加载动画
      if (!loaded) {
        loaded = true;
        const src = $image.getAttribute('data-src');
        if (src) {
          $image.addEventListener('load', () => $box && $box.classList.add('is-loaded'), { once: true });
          $image.src = src;
        } else if ($box) {
          $box.classList.add('is-loaded');
        }
      }

      publish(PUB_SUB_EVENTS.xModalOpen, { modalName: 'accessory-box' });
    });
  }

  function initMobileInlineVideo() {
    const inlineVideos = document.querySelectorAll('.js-mobile-inline-video');

    inlineVideos.forEach((card) => {
      card.addEventListener('click', function () {
        if (window.innerWidth > 768) return;
        if (this.classList.contains('is-playing')) return;

        const videoSrc = this.getAttribute('data-video-src');
        const injectContainer = this.querySelector('.x-unboxing-card__video-inject');

        if (!injectContainer || !videoSrc) return;

        const videoHtml = `
          <video src="${videoSrc}" 
                 controls 
                 autoplay 
                 playsinline 
                 style="width: 100%; height: 100%; object-fit: cover;">
          </video>
        `;

        injectContainer.innerHTML = videoHtml;
        this.classList.add('is-playing');
      });
    });
  }

  function initFAQ() {
    const $faqHeaders = document.querySelectorAll('.x-product-faq__header');
    $faqHeaders.forEach(($header) => {
      $header.addEventListener('click', function () {
        if (window.innerWidth <= 768) {
          const $block = this.closest('.x-product-faq__block');
          $block.classList.toggle('x-product-faq__block--mobile-expanded');

          const $folder = $header.closest('.x-product-feature__item');
          $folder.style.height = 'auto';
        }
      });
    });

    const $faqQuestions = document.querySelectorAll('.x-product-faq__q');
    $faqQuestions.forEach(($q) => {
      $q.addEventListener('click', function () {
        const $item = this.closest('.x-product-faq__item');
        $item.classList.toggle('x-product-faq__item--expanded');

        const $folder = $q.closest('.x-product-feature__item');
        $folder.style.height = 'auto';
      });
    });
  }

  async function init() {
    const urlParams = xUtils.getUrlParams();
    const variantIdFromUrl = urlParams ? urlParams.variant : '';
    const selectedVariantFromUrl = window.VARIANTS.find((v) => v.id == variantIdFromUrl);

    await fetchRealtimeInventory();

    variantInfoTemplate = [];
    document.querySelectorAll('.x-product-variants__option-group').forEach(($group) => {
      const indexKey = $group.getAttribute('data-option-index');
      const nameKey = $group.getAttribute('data-name');
      const $activeItem = $group.querySelector(
        '.x-product-variants__option-item[class*="--active"], .x-product-variants__option-item[class*="--selected"]'
      );
      if ($activeItem) {
        currentSelection[indexKey] = $activeItem.getAttribute('data-value');
      }
      variantInfoTemplate.push(nameKey);
    });

    if (selectedVariantFromUrl) {
      if (variantInfoTemplate.length > 2) {
        currentSelection.option3 = selectedVariantFromUrl.option3;
      } else {
        currentSelection.option2 = selectedVariantFromUrl.option2;
      }
    }

    resolvedVariant = getVariantBySelection(currentSelection);
    updateOptionsUI();

    const $optionsContainer = document.querySelector('.x-product-variants__options-container');
    if ($optionsContainer) {
      $optionsContainer.addEventListener('click', async (e) => {
        const $item = e.target.closest('.x-product-variants__option-item');
        if (!$item) return;
        if ($item.classList.contains('x-product-variants__generic-item--disabled')) return;

        const $group = $item.closest('.x-product-variants__option-group');
        const nameKey = $group.getAttribute('data-name');
        const indexKey = $group.getAttribute('data-option-index');
        const clickedValue = $item.getAttribute('data-value');
        const isSizeChange = nameKey.includes('size');

        if (currentSelection[indexKey] === clickedValue) return;

        currentSelection[indexKey] = clickedValue;

        if (!isSizeChange) {
          await fetchRealtimeInventory();
        }

        resolvedVariant = getVariantBySelection(currentSelection);

        if (!resolvedVariant) {
          resolvedVariant =
            window.VARIANTS.find((v) => v[indexKey] === clickedValue && globalInventoryMap[v.id]) ||
            window.VARIANTS.find((v) => v[indexKey] === clickedValue);

          if (resolvedVariant) {
            if (resolvedVariant.option1) currentSelection.option1 = resolvedVariant.option1;
            if (resolvedVariant.option2) currentSelection.option2 = resolvedVariant.option2;
            if (resolvedVariant.option3) currentSelection.option3 = resolvedVariant.option3;
          }
        }

        updateOptionsUI();

        if (resolvedVariant) {
          // 3：动态获取参数组总数量并推断是否满足“双端大类特征变动条件”
          const totalOptions = document.querySelectorAll(
            '.x-product-variants__option-group'
          ).length;
          const shouldUpdateFeatures = totalOptions === 3 && indexKey === 'option1';

          // 将判定标志位安全向下分发给数据抓取引擎
          await fetchVariantData(resolvedVariant.id, isSizeChange, shouldUpdateFeatures);
        }
      });
    }

    document.addEventListener('submit', (e) => {
      const $targetForm = e.target.closest('form[data-type="add-to-cart-form"]');
      if (!$targetForm) return;

      const totalOptions = document.querySelectorAll('.x-product-variants__option-group').length;
      const currentSelectedCount = Object.values(currentSelection).filter((val) => val).length;

      if (currentSelectedCount < totalOptions || !resolvedVariant) {
        e.preventDefault();
        e.stopPropagation();

        const $container = document.querySelector('.x-product-variants__options-container');
        if ($container) {
          const y = $container.getBoundingClientRect().top + window.scrollY - 150;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
        return;
      }

      const $buyBtn = $targetForm.querySelector('.x-product__buy-button');
      if ($buyBtn && $buyBtn.getAttribute('data-available') === 'false') {
        e.preventDefault();
        e.stopPropagation();

        const currentCountry = $buyBtn.getAttribute('data-country');
        if (currentCountry !== 'US') return;

        handleDynamicWaitlistForm($targetForm);
      }
    });

    initVariantSlider();
    initLightGallery();
    initToggleButtonArea();
    initVideoAutoPlay();
    initStoryVideoAutoPlay();
    initSizeGuide();
    initSizeRecommend();
    initAssemblingVideo();
    initAccessoryModal();
    initMobileInlineVideo();
    initFAQ();

    const $buyBtn = document.querySelector('.x-product__buy-button');
    if ($buyBtn) $buyBtn.removeAttribute('hidden');
  }

  init();
});
